export const UMAMI_SCRIPT_URL = 'https://umami.warflix.net/script.js';

/**
 * Adds the self-hosted Umami tracking script for the given website id, so
 * dev and production report to separate Umami websites (the id comes from
 * the build's environment file). A blank id — local `ng serve` — adds nothing.
 * Umami follows the router's pushState navigations on its own.
 */
export function loadUmami(websiteId: string, doc: Document = document): void {
  if (!websiteId) return;

  const script = doc.createElement('script');
  script.defer = true;
  script.src = UMAMI_SCRIPT_URL;
  script.setAttribute('data-website-id', websiteId);
  doc.head.appendChild(script);
}
